var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgIconEmail = function SvgIconEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
    "data-name": "@",
    transform: "translate(0 16)",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "@"))));
};
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0iY3VycmVudENvbG9yIiB2aWV3Qm94PSIwIDAgMjAgMjAiPg0KICA8dGV4dCBkYXRhLW5hbWU9IkAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMTYpIiBmb250LXNpemU9IjIwIiBmb250LWZhbWlseT0iU2Vnb2VVSSwgU2Vnb2UgVUkiPjx0c3BhbiB4PSIwIiB5PSIwIj5APC90c3Bhbj48L3RleHQ+DQo8L3N2Zz4NCg==";
export { SvgIconEmail as ReactComponent };